import React, { useRef } from 'react'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import { Box, Grid } from '@mui/material'
import OneButton from '../OneButton/OneButton'
import { CheckOutlined, ReplayOutlined } from '@mui/icons-material'

const ImgCrop = ({ imgSrc, callbackFinalizar, callbackTirarFotoNovamente }) => {
    const cropperRef = useRef(null)

    const handleCrop = () => {
        const cropperInstance = cropperRef.current?.cropper
        if (cropperInstance) {
            const croppedImage = cropperInstance.getCroppedCanvas().toDataURL()
            callbackFinalizar(croppedImage)
        }
    }

    const TirarFotoNovamente = () => {
        callbackTirarFotoNovamente()
    }

    return (
        <div>
            {imgSrc && (
                <Grid container spacing={2} style={{ width: '100%' }}>
                    <Grid item xs={12}>
                        <Cropper
                            style={{ height: 400, width: '100%' }}
                            src={imgSrc}
                            viewMode={1}
                            initialAspectRatio={1}
                            aspectRatio={1}
                            guides={true}
                            ref={cropperRef}
                            cropBoxMovable={true}
                            minCropBoxHeight={10}
                            minCropBoxWidth={10}
                            background={false}
                            responsive={true}
                            autoCropArea={1}
                            checkOrientation={false}
                            preview=".img-preview"
                        />
                    </Grid>
                </Grid>
            )}

            <Box marginTop={2} textAlign="center">
                <div
                    className="img-preview"
                    style={{
                        width: '300px',
                        height: '300px',
                        overflow: 'hidden',
                        border: '1px solid #ccc'
                    }}
                />
            </Box>

            <Box style={{ justifyContent: 'center', display: 'flex', marginTop: '20px' }}>
                <OneButton
                    variant="contained"
                    color="one_primary"
                    backgroundColor='true'
                    IconStart={ReplayOutlined}
                    sxIconStart={{ width: '20px' }}
                    onClick={TirarFotoNovamente}
                >
                Tirar Nova Foto
                </OneButton>

                <OneButton
                    variant="contained"
                    color="success"
                    backgroundColor='true'
                    IconStart={CheckOutlined}
                    sxIconStart={{ width: '20px' }}
                    onClick={handleCrop}
                >
                Finalizar
                </OneButton>
            </Box>
        </div>
    )
}

export default ImgCrop
